import React, { useCallback } from 'react';
import CustomCollapse from '../shared/collapse';
import apiCalls from 'src/api/apiCalls';
import Loader from '../shared/loader.component';
import CollapseData from './collapsedata';
import { badge } from 'src/utils/statusColorsCode';

const CaseDocuments = ({ documents, dispatch, caseData }) => {
  const [documentStates, setDocumentStates] = React.useState({});
  const handleCaseReplies = async (id) => {
    try {
      const response = await apiCalls.getDocumentReplies(id);
      if (response.ok) {
        setDocumentStates((prev) => ({
          ...prev,
          [id]: { loading: false, repository: response.data },
        }));
      } else {
        setDocumentStates((prev) => ({
          ...prev,
          [id]: { loading: false, repository: [] },
        }));
        dispatch({
          type: 'SET_ERROR',
          payload: apiCalls.isErrorDispaly('Error fetching case data'),
        });
      }
    } catch (error) {
      setDocumentStates((prev) => ({
        ...prev,
        [id]: { loading: false, repository: [] },
      }));
      dispatch({
        type: 'SET_ERROR',
        payload: apiCalls.isErrorDispaly(error.message),
      });
    }
  };
  const handleCollapseChange = useCallback(
    async (changedPanels) => {
      await Promise.all(
        changedPanels.map(async (panel) => {
          const selectedKey = panel.id;
          const selectedState = panel.state;
          if (selectedState) {
            setDocumentStates((prev) => ({
              ...prev,
              [selectedKey]: { loading: true, repository: null },
            }));
            dispatch({ type: 'SET_DOCUNET_DETAIL_ID', payload: selectedKey });
            await handleCaseReplies(selectedKey);
          }
        })
      );
    },
    [dispatch, handleCaseReplies]
  );
  const items = documents?.map((doc) => {
    const docState = documentStates[doc.id] || {};
    let childrenContent;
    if (docState?.loading) {
      childrenContent = (
        <div className="flex justify-center items-center mt-20">
          <Loader />
        </div>
      );
    } else {
      childrenContent = (
        <CollapseData
          docRepository={docState.repository}
          docunetDetailId={doc.id}
          state={doc.state}
          caseData={caseData}
        />
      );
    }
    return {
      key: doc.id,
      label: (
        <div className="flex items-center justify-between">
          <h4 className="text-subTextColor text-sm font-medium">
            {doc.documentName}
          </h4>
          <p className={`status-badge font-medium !text-primaryColor ${badge[doc.state?.toLowerCase()] || "bg-green"}`}>
            {doc.state}
          </p>
        </div>
      ),
      children: childrenContent,
    };
  });
  return <CustomCollapse items={items} onChange={handleCollapseChange} />;
};
export default CaseDocuments;
